<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex">
				<div class="grid md:grid-cols-2 gap-4" v-if="!isLoading">
					<div v-for="variable in variables" :key="variable.id">
						<CompanyVariable
							:variable="variable"
							@input="editValue = true"
							:required="true"
							:ref="'companyVariable' + variable.key"
							label-class="md:min-h-12 lg:min-h-12 xxl:min-h-full"
						/>
					</div>

					<div class="" v-if="variableCustom">
						<div class="flex w-full font-bold mb-2 md:min-h-12 xxl:min-h-6" style="color: #495057">{{ $t('customizable_input_field') }}</div>
						<div class="flex flex-row gap-4">
							<BaseInput v-model="variableCustom.label" @input="$emit('input')" ref="text" class="w-2/3" :required="false" />
							<BaseInputNumber v-model="variableCustom.value" ref="number" class="w-1/3" :precision="2" :required="false" />
						</div>
					</div>
				</div>
				<LoadingSpinner v-else />
			</div>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import CompanyVariable from '@/views/usermanagment/CompanyVariable.vue';
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber.vue';
import CompanyVariablesRepository from '@/api/repositories/CompanyVariablesRepository';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import Validate from '@/mixins/Validate';

export default {
	components: { LoadingSpinner, BaseInputNumber, CompanyVariable, BaseInput },
	name: 'OnboardingCompanyVariablesForm',
	mixins: [Validate, Authentication],
	data() {
		return {
			variables: {},
			editValue: false,
			isLoading: false,
			variableCustom: null,
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAuthenticatedUserInGroupAdmin) {
			this.isLoading = true;
			this.fetchCompanyVariables();
		}
	},
	methods: {
		fetchCompanyVariables() {
			new CompanyVariablesRepository()
				.getAll()
				.then(response => {
					this.variables = response.data.data.filter(variable => !variable.key.includes('custom_field'));
					if (!response.data.data.find(variable => variable.key.includes('custom_field'))) {
						this.variableCustom = { id: null, key: 'custom_field', label: '', value: null, type: 'number' };
					} else {
						this.variableCustom = response.data.data.find(variable => variable.key.includes('custom_field'));
					}

					this.isLoading = false;
				})
				.catch(error => {
					this.$store.dispatch('reportLogs');
					this.$swal(this.$t('error').toString(), this.$t('no_values_found').toString(), 'error');
					this.isLoading = false;
				});
		},
		getData() {
			if (!this.variableCustom.value || isNaN(this.variableCustom.value)) {
				if (this.variableCustom.label) {
					this.$swal(this.$t('general.error').toString(), this.$t('custom_field_error').toString(), 'error');
					return null;
				} else {
					this.variableCustom.value = null;
				}
			} else if (!this.variableCustom.label) {
				this.$swal(this.$t('general.error').toString(), this.$t('custom_field_label_error').toString(), 'error');
				return null;
			}
			if (this.variableCustom.label === '0') {
				this.variableCustom.value = null;
				this.variableCustom.label = '';
			}

			return [...this.variables, this.variableCustom];
		},
	},
};
</script>
